'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModelAnalyticsResource = function () {
  function ModelAnalyticsResource($http) {
    (0, _classCallCheck3.default)(this, ModelAnalyticsResource);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      MODELS: 'model-analytics/models/',
      GRADES: 'model-analytics/grades/'
    };
  }

  (0, _createClass3.default)(ModelAnalyticsResource, [{
    key: 'models',
    value: function models(params) {
      return this.$http.get(this.PATH.MODELS, { params: params });
    }
  }, {
    key: 'grades',
    value: function grades(params) {
      return this.$http.get(this.PATH.GRADES, { params: params });
    }
  }]);
  return ModelAnalyticsResource;
}();

exports.default = ModelAnalyticsResource;


//////////////////
// WEBPACK FOOTER
// ./src/api/ModelAnalyticsResource.js
// module id = 334
// module chunks = 0